import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { formatBadge, useUnreadCount } from "../hooks/useUnreadCount";

/** Header icon (desktop) with the unread badge. */
export function MessagesNavButton() {
  const { t } = useTranslation();
  const unread = useUnreadCount();
  const badge = formatBadge(unread);
  return (
    <Link
      to="/messages"
      aria-label={`${t("chat.title")}${unread ? `, ${t("chat.aria.unreadBadge", { count: unread })}` : ""}`}
      title={t("chat.title")}
      className="relative flex h-10 w-10 items-center justify-center rounded-full text-slate-600 transition hover:bg-blue-50 hover:text-blue-600"
    >
      <MessageCircle size={22} />
      {badge && (
        <span className="absolute -right-0.5 -top-0.5 min-w-[18px] rounded-full bg-blue-600 px-1 py-px text-center text-[10px] font-bold leading-[14px] text-white ring-2 ring-white">
          {badge}
        </span>
      )}
    </Link>
  );
}
